module.exports = __webpack_public_path__ + "img/4902720092085_2.dadd27a4.png";